import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevronup--menu",
  "use": "icon-chevronup--menu-usage",
  "viewBox": "0 0 47.37 20.613",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 47.37 20.613\" id=\"icon-chevronup--menu\">\n<g id=\"icon-chevronup--menu_chevronup--menu\">\n\t<polygon style=\"fill:#808080;\" points=\"23.686,0 0,15.604 3.301,20.613 23.686,7.186 44.069,20.613 47.37,15.604 \t\" fill=\"currentColor\" />\n</g>\n<g id=\"icon-chevronup--menu_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol